export default __webpack_public_path__ + "static/media/donate_banner.8de409c9.png";